import { CautionModal } from "./caution-modal"
import { AlertModal } from "./alert-modal"

/** Mounted once in AppLayout; renders every globally-triggered modal. */
export function ModalRoot() {
  return (
    <>
      <CautionModal />
      <AlertModal />
    </>
  )
}
